import React, { PureComponent } from 'react'
import NavBar from '../../../components/navBar/nav-bar';
import './flow-detail.scss';
import storeImg from '../../../assets/img/repository/storeIcon.png';
import moment from 'moment';
import { LogisticsService } from '../../../service/logistics.service';
import { PageOption } from '../../../model';
import NoResult from '../../../components/no-result/no-result';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import download from '../../../assets/img/download.png';
import { Modal, List, Button, Toast } from 'antd-mobile';
import ClipboardJS from 'clipboard';

@observer
export default class FlowDetail extends PureComponent<any, any> {

  pageOption: PageOption = {
    page: 1,
    rows: 20,
    total: 0
  };

  @observable noResult: boolean = false;

  query: {start_time: string, end_time: string, goods_num: string};

  constructor(props: any) {
    super(props);
    this.state = {
      dataList: [],
      downloadVisible: false,
      currentUrl: '',
      loading: false,
      goods_order_sum: 0,
      goods_sales: 0,
      goods_total_fee: 0
    };
    this.query = {
      goods_num: this.props.match.params.goods_num,
      start_time: this.props.match.params.start_time,
      end_time: this.props.match.params.end_time
    };
    this.getList();
    const clipBoard = new ClipboardJS('.flowInquiryBtn');
    clipBoard.on('success', () => {
      Toast.info('复制成功！');
      this.setState({
        downloadVisible: false
      })
    })
  }

  async getList() {
    if (!this.state.loading) {
      this.noResult = false;
      const data = await LogisticsService.getListDetail(this.pageOption, this.query);
      this.pageOption.page = data.list.current_page;
      this.pageOption.rows = +data.list.per_page;
      this.pageOption.total = +data.list.total;
      this.setState({
        dataList: [...this.state.dataList, ...data.list.data],
        goods_order_sum: data.goods_order_sum,
        goods_sales: data.goods_sales,
        goods_total_fee: data.goods_total_fee,
      });
      this.setState({
        loading: false
      });
      if (!this.state.dataList.length) {
        this.noResult = true;
      }
    }
  }

  pageSearch() {
    this.pageOption.page++;
    this.setState({
      loading: true
    });
    this.getList();
  }

  scrollLoad = ({target}: any) => {
    if (this.state.dataList.length >= this.pageOption.total) { return ; }
    if ((target.scrollHeight - target.clientHeight - target.scrollTop) < 10 ) {
      this.pageSearch();
    }
  }

  formatDate(date: any) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  }

  downLoad = async () => {
    Toast.loading('加载中...', 0);
    const data = await LogisticsService.download(this.query.start_time, this.query.end_time);
    this.setState({
      downloadVisible: true,
      currentUrl: data.url
    });
    Toast.hide();
  }

  copyUrl = () => {

  }

  inquiryList() {
    return this.state.dataList.map((item: any, index: number) => {
      return <div className="item" key={index}>
        <div className="medName">
          <img src={storeImg} alt=""></img>
          <div className="name">{item.goods_name + (item.name? `(${item.name})`: '')}</div>
        </div>
        <div className="line"></div>
        <div className="detailParams">
          <div className="param">
            <div className="paramName">业务日期</div>
            <div className="paramValue">{item.logic_time}</div>
          </div>
          <div className="param">
            <div className="paramName">单位名称</div>
            <div className="paramValue">{item.company_name}</div>
          </div>
          <div className="param">
            <div className="paramName">业务类型</div>
            <div className="paramValue">{item.logic_type}</div>
          </div>
          <div className="param">
            <div className="paramName">规格</div>
            <div className="paramValue">{item['规格']}</div>
          </div>
          <div className="param">
            <div className="paramName">单位</div>
            <div className="paramValue">{item['单位']}</div>
          </div>
          <div className="param">
            <div className="paramName">数量</div>
            <div className="paramValue">{item['数量']}</div>
          </div>
          <div className="param">
            <div className="paramName">剂型</div>
            <div className="paramValue">{item['剂型']}</div>
          </div>
          <div className="param">
            <div className="paramName">厂商</div>
            <div className="paramValue">{item.production}</div>
          </div>
          <div className="param">
            <div className="paramName">销售员</div>
            <div className="paramValue">{item.salemanname}</div>
          </div>
          {/*<div className="param">
            <div className="paramName">含税售价</div>
            <div className="paramValue">{item.rate_price}</div>
          </div>
          <div className="param">
            <div className="paramName">含税销额</div>
            <div className="paramValue">{item.rate_price_total}</div>
          </div>*/}
        </div>
      </div>;
    });
  }

  render() {
    return (
      <div className="flowDetail" onScroll={this.scrollLoad} style={{paddingTop: "0"}}>
        <div className="header">
          <NavBar title="流向查询"></NavBar>
        </div>
        <div className="flowDetailPool">
          <div>
            <span>商品订单数</span>
            <span>{this.state.goods_order_sum}</span>
          </div>
          <div>
            <span>商品销量</span>
            <span>{this.state.goods_sales}</span>
          </div>
          <div>
            <span>商品销售总价</span>
            <span>￥{this.state.goods_total_fee}</span>
          </div>
        </div>
        <div className="flowDetailList">
          { this.inquiryList() }
          { this.noResult && <NoResult></NoResult>}
        </div>
        {/*<img className="downLoad" alt="download" src={download} onClick={this.downLoad}/>
        <Modal
          popup = {true}
          visible={this.state.downloadVisible}
          onClose={() => this.setState({downloadVisible: false})}
          animationType="slide-up"
        >
          <List renderHeader={() => <div className="flowInquiryInputUrlTitle">复制下载地址</div>} className="popup-list">
            <div className="flowInquiryInputUrl">
              <div className="tip">(请复制连接到手机自带浏览器进行下载)</div>
              <input id="flowInquiryInputUrl" readOnly defaultValue={this.state.currentUrl} />
            </div>
            <List.Item>
              <Button type="primary" className="flowInquiryBtn" onClick={this.copyUrl} data-clipboard-action="copy" data-clipboard-target="#flowInquiryInputUrl">复制地址</Button>
            </List.Item>
          </List>
        </Modal>*/}
      </div>
    )
  }
}
